import React, { Suspense } from "react";
import useAuthStore from "../store/authStore";

const AdminRoutes = React.lazy(() => import("../routes/admin.routes"));
const UserRoutes = React.lazy(() => import("../routes/user.routes"));
const GuestRoutes = React.lazy(() => import("../routes/guest.routes"));

const RoutesList = () => {
    const { user } = useAuthStore();
    const role = user?.role;

    let RoutesTree = GuestRoutes;

    if (role === "admin" || role === "superadmin") {
        RoutesTree = AdminRoutes;
    } else if (role === "user") {
        RoutesTree = UserRoutes;
    }

    return (
        <Suspense fallback={null}>
            <RoutesTree />
        </Suspense>
    );
};

export default RoutesList;
